$(document).ready(function () {
    $('.date-details-toggle').on('click', function (e) {
        e.preventDefault();
        let $parent = $(this).closest('.workshop-info');
        $parent.find('.date-details-toggle .caret').toggleClass('open');
        $parent.find('.date-details').slideToggle();
    });
});
